import React from 'react';
import { Select } from 'tea-component';
import './index.scss';
import { IEventNameSelectProps } from '@/pages/dashboard/filterPageComponents/eventAnalysis/EventExplorationFilter/components/EventFilter/components/EventFilterContent/components/EventNameSelect/type';

const EventNameSelect: React.FC<IEventNameSelectProps> = ({
  value,
  onChange,
  options,
  placeholder,
  groups,
  selectProps,
}) => {
  return (
    <Select
      appearance="button"
      className='dbd-event-filter-content__name-select'
      overlayClassName='dbd-event-filter-content__name-select__overlay'
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      options={options}
      groups={groups}
      {...selectProps}
    />
  );
};

export default EventNameSelect;
